import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import fetch from 'cross-fetch';

var _getErrorMessage = function _getErrorMessage(err) {
  return err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
};

var handleError = function handleError(error, reject) {
  if (typeof error.json !== 'function') {
    return reject(error);
  }

  error.json().then(function (err) {
    return reject({
      message: _getErrorMessage(err),
      status: (error === null || error === void 0 ? void 0 : error.status) || 500
    });
  });
};

var _getRequestParams = function _getRequestParams(method, options, parameters, body) {
  var params = {
    method: method,
    headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
  };

  if (method === 'GET') {
    return params;
  }

  params.headers = Object.assign({
    'Content-Type': 'application/json'
  }, options === null || options === void 0 ? void 0 : options.headers);
  params.body = JSON.stringify(body);
  return Object.assign(Object.assign({}, params), parameters);
};

function _handleRequest(method, url, options, parameters, body) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              fetch(url, _getRequestParams(method, options, parameters, body)).then(function (result) {
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return resolve(result);
                return result.json();
              }).then(function (data) {
                return resolve(data);
              }).catch(function (error) {
                return handleError(error, reject);
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

export function get(url, options, parameters) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _handleRequest('GET', url, options, parameters));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function post(url, body, options, parameters) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _handleRequest('POST', url, options, parameters, body));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}
export function put(url, body, options, parameters) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _handleRequest('PUT', url, options, parameters, body));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}
export function remove(url, body, options, parameters) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _handleRequest('DELETE', url, options, parameters, body));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}